export const MAX_SOLIDARY_TENANTS = 2;

export const SOLIDARY_TENANTS_MAX_MESSAGE = `O máximo é ${MAX_SOLIDARY_TENANTS} locatários solidários por análise`;

export const getSolidaryTenantsLimit = (clientTenantSolidarityNum?: number | null): number =>
	Math.min(Number(clientTenantSolidarityNum) || 1, MAX_SOLIDARY_TENANTS);
